module.exports = __webpack_public_path__ + "img/Group 95.3b14aee0.png";